import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const schemaWebPage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '高潮喷水完全指南：原理、技巧与健康知识',
    description: '系统讲解高潮喷水生理原理、发生机制、常见误区及健康知识，帮助读者科学了解高潮喷水现象，消除困惑，建立正确的身体认知与性健康意识。',
    url: 'https://cbhfyv.cn/',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '高潮喷水完全指南',
      url: 'https://cbhfyv.cn/',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaWebPage) }}
      />
      <HeroSection />
      <CategoryGrid />
      <FeaturedArticles />
      <FAQSection />
      <NewsletterSection />
    </>
  );
}